import { render, staticRenderFns } from "./LightningTemplate.vue?vue&type=template&id=13188e3c"
import script from "./LightningTemplate.vue?vue&type=script&lang=js"
export * from "./LightningTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports